import React from "react";
import { motion } from "framer-motion";
import {
  FaGlobeAsia,
  FaLeaf,
  FaIndustry,
} from "react-icons/fa";

const goalData = [
  {
    title: "Expand Across India",
    desc: "Bringing premium hardware, plywood, laminates and door solutions closer to customers through strategic growth.",
    icon: <FaGlobeAsia />,
    color: "#3B82F6",
  },
  {
    title: "Smart Manufacturing",
    desc: "Investing in precision technology and advanced machinery to ensure superior quality and consistency.",
    icon: <FaIndustry />,
    color: "#F97316",
  },
  {
    title: "Sustainable Future",
    desc: "Building an environmentally responsible future through eco-friendly sourcing and production practices.",
    icon: <FaLeaf />,
    color: "#10B981",
  },
];


export default function FutureGoals() {
  return (


  <>


  <style>{`
    .future-goal-card{
  background: rgba(255,255,255,.75);
  backdrop-filter: blur(18px);
  border-radius: 30px;
  padding: 40px;
  height: 100%;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(249,115,22,.12);
  box-shadow: 0 20px 50px rgba(15,23,42,.08);
}

@media (max-width: 768px){
  .future-goal-card{
    padding: 24px !important;
    border-radius: 22px !important;
  }

  .future-goal-card h4{
    font-size: 1.15rem !important;
  }

  .future-goal-card p{
    font-size: 0.92rem !important;
    line-height: 1.6 !important;
  }
}




.future-icon{
  width:80px;
  height:80px;
  font-size:2rem;
}

@media (max-width:768px){
  .future-icon{
    width:60px;
    height:60px;
    font-size:1.5rem;
    border-radius:18px;
    margin-bottom:18px !important;
  }
}


@media (max-width:768px){
  .future-goal-card span{
    font-size:3rem !important;
  }
}
      
      `}</style>


    <section
      className="pb-3 pt-3 position-relative overflow-hidden"
      style={{
        background: "#F8FAFC",
      }}
    >
      {/* Floating Background Blobs */}

      <motion.div
        animate={{
          y: [-20, 20, -20],
          x: [-15, 15, -15],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
        }}
        style={{
          position: "absolute",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: "rgba(249,115,22,.08)",
          top: "10%",
          left: "-100px",
          filter: "blur(60px)",
        }}
      />

      <motion.div
        animate={{
          y: [20, -20, 20],
          x: [15, -15, 15],
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
        }}
        style={{
          position: "absolute",
          width: "350px",
          height: "350px",
          borderRadius: "50%",
          background: "rgba(249,115,22,.05)",
          right: "-100px",
          bottom: "5%",
          filter: "blur(70px)",
        }}
      />

      <div className="container py-lg-5">
        {/* Header */}

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-5 position-relative"
        >
          <span
            style={{
              color: "#F97316",
              letterSpacing: "4px",
              fontWeight: 700,
              textTransform: "uppercase",
            }}
          >
            Our Vision
          </span>

          <h2
            style={{
              fontSize: "clamp(2rem,4vw,3.5rem)",
              fontWeight: 900,
              lineHeight: "1.1",
              marginTop: "15px",
              color: "#111827",
            }}
          >
            Building The
            <br />
            <span style={{ color: "#F97316" }}>
              Future of Excellence
            </span>
          </h2>

          <p
            style={{
              maxWidth: "750px",
              margin: "20px auto 0",
              color: "#64748B",
              fontSize: "1.05rem",
              lineHeight: "1.8",
            }}
          >
            Our journey continues with innovation, expansion and
            sustainability, ensuring every project receives the
            highest quality products and service.
          </p>
        </motion.div>

        {/* Cards */}

        <div className="row g-3 g-lg-4">
          {goalData.map((goal, index) => (
            <div className="col-lg-4" key={index}>
              <motion.div
                className="future-goal-card"
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.7,
                  delay: index * 0.2,
                }}
                whileHover={{
                  y: -12,
                  scale: 1.03,
                }}
                style={{
                  background: "rgba(255,255,255,.75)",
                  backdropFilter: "blur(18px)",
                  padding: window.innerWidth < 768 ? "24px" : "40px",
                  borderRadius: window.innerWidth < 768 ? "22px" : "30px",
                  height: "100%",
                  position: "relative",
                  overflow: "hidden",
                  border: "1px solid rgba(249,115,22,.12)",
                  boxShadow:
                    "0 20px 50px rgba(15,23,42,.08)",
                }}
              >
                {/* Number */}

                <span
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "10px",
                    fontSize: "5rem",
                    fontWeight: 900,
                    color: goal.color,
                    opacity: 0.15,
                    zIndex: 0,
                  }}
                >
                  0{index + 1}
                </span>

                {/* Icon */}

                <motion.div
                  className="future-icon"
                  animate={{
                    y: [0, -8, 0],
                    rotate: [0, 5, -5, 0],
                  }}
                  transition={{
                    duration: 4,
                    repeat: Infinity,
                  }}
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "24px",
                    background: `${goal.color}15`,
                    color: goal.color,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "2rem",
                    marginBottom: "25px",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  {goal.icon}
                </motion.div>

                <div style={{ position: "relative", zIndex: 1 }}>
                  <h4
                    style={{
                      fontWeight: 800,
                      marginBottom: "15px",
                      color: "#111827",
                    }}
                  >
                    {goal.title}
                  </h4>

                  <p
                    style={{
                      color: "#64748B",
                      lineHeight: "1.8",
                      marginBottom: "25px",
                    }}
                  >
                    {goal.desc}
                  </p>
                </div>

                {/* Bottom Hover Bar */}

                <motion.div
                  initial={{ width: 0 }}
                  whileHover={{ width: "100%" }}
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    height: "4px",
                    background: goal.color,
                  }}
                />
              </motion.div>
            </div>
          ))}
        </div>

        {/* Stats Section */}

        {/* <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="row mt-5 text-center"
        >
          <div className="col-md-3 col-6 mb-4">
            <h2
              style={{
                color: "#F97316",
                fontWeight: 900,
                fontSize: "3rem",
              }}
            >
              15+
            </h2>
            <p className="text-muted mb-0">
              Years Experience
            </p>
          </div>

          <div className="col-md-3 col-6 mb-4">
            <h2
              style={{
                color: "#F97316",
                fontWeight: 900,
                fontSize: "3rem",
              }}
            >
              5000+
            </h2>
            <p className="text-muted mb-0">
              Happy Customers
            </p>
          </div>

          <div className="col-md-3 col-6 mb-4">
            <h2
              style={{
                color: "#F97316",
                fontWeight: 900,
                fontSize: "3rem",
              }}
            >
              100+
            </h2>
            <p className="text-muted mb-0">
              Premium Brands
            </p>
          </div>

          <div className="col-md-3 col-6 mb-4">
            <h2
              style={{
                color: "#F97316",
                fontWeight: 900,
                fontSize: "3rem",
              }}
            >
              98%
            </h2>
            <p className="text-muted mb-0">
              Satisfaction Rate
            </p>
          </div>
        </motion.div> */}
      </div>
    </section>
  </>
  );
}